<template>
  <v-row>
    <v-col cols="12" REGISTER ALERT v-if="user && !user.verified_email && !user.onboarding">
      <v-dialog v-model="dialog" persistent fullscreen>
        <v-card>
          <v-card-title :class="`${arabic?'arFont':'enFont'}`"  style="font-size:20px">
            <v-row class="align-center fill-height">
              <v-col cols="12" md="11" :class="`${arabic?'arFont':'enFont'} fill-height`">
                {{ i18n["welcome_to_ninja_sellers"] }}
                
              </v-col>
              <v-col cols="12" md="1" :class="`${arabic?'arFont':'enFont'} fill-height`">
                <v-btn text @click="signOut()" :class="`${arabic?'arFont':'enFont'}`">
                  <span class="primary--text">{{i18n.logout}}</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row class="align-center fill-height">
              <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} fill-height`">
                <v-card v-if="!user.verified_email">
                  <v-card-text :class="`${arabic?'arFont':'enFont'}`">
                    
                    <h2 :class="`${arabic?'arFont':'enFont'}`">{{ i18n["confirm_email_instructions"] }}</h2>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="primary" :class="`${arabic?'arFont':'enFont'}`" @click="sendEmail()">
                      {{ i18n["send_confirmation_email"] }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} fill-height`">
                {{ i18n['contact_support_via_whatsapp'] }}:  <a href="https://api.whatsapp.com/send?phone=447883307413">
                  447883307413
                  <img height="30px" src="/images/WhatsApp.png">
                </a>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import countries from '../countries-ash.json'
export default {
  data() {
      return {
        dialog:true,
        phone_number:null,
        country_code:null,
        submit:null,
        loading:null,
        secret:null,
        stepper:1,
        countries:countries.map(x=>{return{...x, callingCodes:x.callingCodes[0]}}),
        session_token:null,
        live:null,
        live_check:null,
        seminar:null,
      }
  },
  methods:{
    clearStore(){
      this.$store.state.access_token = null
      this.$store.state.user = null
      this.$store.state.uid = null
      this.$store.state.centralLogin = false
      this.$store.state.menu = []
      this.$store.state.globalLoading = false
      this.$store.state.users = []
      this.$store.state.goals = []
      this.$store.state.keyResults = []
      this.$store.state.initiatives = []
      this.$store.state.documents = []
      this.$store.state.notifications = []
      this.$store.state.approvals = []
      this.$store.state.usersLevels = []
      this.$store.state.reports = []
      this.$store.state.othersGoals = []
      localStorage.country = null
      localStorage.cart = JSON.stringify([])
      localStorage.manual_country = false
    },
    async signOut() {
      try {
        await this.$store.dispatch('logout')
      } catch (error) {
        // console.log(error)
      }
      this.clearStore()
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    async sendSMS() {
      return new Promise(async(res, rej)=>{
        this.loading = true
        if(!this.phone_number) {
          this.$emit('snackbarNotification', this.i18n['phone_required'], 'error')
          this.loading = false
        }
        this.submit = true
        let r = await this.$store.dispatch('postResource', {resource:'/phone-verification', value:{phone_number:`${this.country_code}${this.phone_number}`}})
        this.session_token = r.session_token
        
        this.loading = false
      })
    },
    async sendSecret() {
      return new Promise(async(res, rej)=>{
        this.loading = true
        if(!this.secret) {
          this.$emit('snackbarNotification', this.i18n["please_input_code"], 'error')
          this.loading = false
        }
        let s_o = { secret:this.secret, session_token:this.session_token, phone_number:`${this.country_code}${this.phone_number}` }
        let r = await this.$store.dispatch('postResource', {resource:'/phone-verification-check', value:s_o})
        if(r.error) {
          this.$emit('snackbarNotification', this.i18n["wrong_code_try_again"], 'error')
          this.submit = false
          this.secret = null
        } else {
          this.secret = null
          this.stepper++
          this.$store.state.user = await this.$store.dispatch('getUser')
          this.$emit('snackbarNotification', this.i18n["phone_verification_success"] , 'success')
        }
        
        this.loading = false
      })
    },
    async sendEmail() {
      return new Promise(async(res, rej)=>{
        this.loading = true
        let r = await this.$store.dispatch('getResource', {resource:'/email-reverification/' + this.user.id})
        this.$emit('snackbarNotification', this.i18n['link_sent_to_email'], 'success')
        
        this.loading = false
      })
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async getSeminar(){
      return new Promise(async(res, rej) => {
        let r = await this.$store.dispatch('getResource', {resource:'/get-cache/seminarlink'});
        
        this.seminar = r.data
        res()
      })
    },
    async startSeminar(){
      return new Promise(async(res, rej) => {
        let r = await this.$store.dispatch('getResource', {resource:'/get-cache/seminarlink'});
        window.open(r.data.seminar_url, '_blank');
        let r2 = await this.$store.dispatch('getResource', {resource:'/user/endboarding'});
      })
    },
    async refresh(){
      return new Promise(async (res, rej)=>{
        let r = await this.$store.dispatch('getResource', {resource:'/check-seminar-time'})
        this.live_check = r
        this.live = r.live
        res()
      })
    },
    async loop() {
      return new Promise(async (res, rej)=>{
        setInterval(this.refresh, 1000)
        res()
      })
    },
    async init(){
      return new Promise(async (res, rej)=>{
        // await this.loop()
        this.stepper = this.$store.state.user.onboarding_step
        await this.getSeminar()
        await this.refresh()
        res()
      })
    }
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
    paymentMethods(){
      return this.$store.state.paymentMethods
    },
  },
  async created(){
    await this.init()
  }
}
</script>

<style>

</style>